import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type DocumentItem = any; // 👈 replace with your real type (ex: { id: string; name: string; url?: string })

export interface DocumentsState {
  documents: DocumentItem[];
}

const initialState: DocumentsState = {
  documents: [],
};

const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    addDocuments(state, action: PayloadAction<DocumentItem[]>) {
      // add many (append)
      state.documents.push(...action.payload);
    },
    addDocument(state, action: PayloadAction<DocumentItem>) {
      // add one
      state.documents.push(action.payload);
    },

    removeDocumentByIndex(state, action: PayloadAction<number>) {
      const index = action.payload;
      if (index >= 0 && index < state.documents.length) {
        state.documents.splice(index, 1);
      }
    },

    resetDocuments() {
      return initialState;
    },
  },
});

export const {
  addDocuments,
  addDocument,
  removeDocumentByIndex,
  resetDocuments,
} = documentsSlice.actions;

export default documentsSlice.reducer;

export const selectDocuments = (state: { documents: DocumentsState }) =>
  state.documents.documents;
